var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 258,
    viewBox: "0 0 256 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.46298 127.456C5.45698 149.133 11.121 170.299 21.891 188.955L4.43298 252.697L69.665 235.593C87.7073 245.415 107.922 250.562 128.465 250.563H128.519C196.334 250.563 251.537 195.38 251.566 127.553C251.579 94.6861 238.791 63.7801 215.557 40.5281C192.327 17.2781 161.432 4.46715 128.514 4.45215C60.691 4.45215 5.49198 59.6321 5.46398 127.456",
    fill: "url(#paint0_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07 127.416C1.063 149.873 6.93 171.796 18.084 191.12L0 257.147L67.571 239.43C86.189 249.581 107.151 254.933 128.481 254.941H128.536C198.784 254.941 255.97 197.773 256 127.518C256.012 93.47 242.764 61.453 218.7 37.368C194.633 13.286 162.633 0.014 128.536 0C58.276 0 1.098 57.16 1.07 127.416ZM41.311 187.792L38.788 183.787C28.182 166.923 22.584 147.435 22.592 127.424C22.614 69.029 70.138 21.52 128.576 21.52C156.876 21.532 183.472 32.564 203.476 52.58C223.479 72.598 234.486 99.208 234.479 127.51C234.453 185.905 186.928 233.42 128.536 233.42H128.494C109.481 233.41 90.834 228.304 74.572 218.655L70.702 216.36L30.604 226.873L41.311 187.792Z",
    fill: "url(#paint1_linear_34_32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.678 74.1479C94.292 68.8449 91.781 68.7379 89.512 68.6449C87.654 68.5649 85.53 68.5709 83.408 68.5709C81.284 68.5709 77.833 69.3699 74.916 72.5549C71.996 75.7429 63.768 83.4469 63.768 99.1159C63.768 114.786 75.181 129.929 76.772 132.056C78.365 134.179 98.805 167.363 131.177 180.129C158.081 190.738 163.556 188.628 169.395 188.096C175.235 187.566 188.239 180.394 190.892 172.957C193.547 165.521 193.547 159.147 192.751 157.815C191.955 156.488 189.831 155.691 186.646 154.099C183.46 152.506 167.802 144.801 164.883 143.738C161.963 142.676 159.84 142.146 157.716 145.335C155.592 148.519 149.493 155.691 147.634 157.815C145.777 159.944 143.918 160.209 140.734 158.616C137.547 157.018 127.29 153.659 115.121 142.81C105.653 134.368 99.261 123.943 97.403 120.754C95.545 117.57 97.204 115.844 98.801 114.257C100.232 112.83 101.987 110.538 103.581 108.679C105.169 106.819 105.699 105.492 106.761 103.368C107.824 101.242 107.292 99.3819 106.497 97.7889C105.699 96.1959 99.51 80.4449 96.678 74.1479Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_32",
    x1: 12361.1,
    y1: 24829,
    x2: 12361.1,
    y2: 4.45215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_32",
    x1: 12800,
    y1: 25714.7,
    x2: 12800,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 258,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappLogo);
export default __webpack_public_path__ + "static/media/whatsapp-logo.1b0633429ab439f3b2f41a9d545ae755.svg";
export { ForwardRef as ReactComponent };